// MSAL error codes that should be handled gracefully
export const MSAL_ERROR_CODES = {
  BLOCK_NESTED_POPUPS: "block_nested_popups",
  POPUP_WINDOW_ERROR: "popup_window_error",
  MONITOR_WINDOW_TIMEOUT: "monitor_window_timeout",
  USER_CANCELLED: "user_cancelled",
  HASH_EMPTY_ERROR: "hash_empty_error",
  POST_REQUEST_FAILED: "post_request_failed",
  INTERACTION_REQUIRED: "interaction_required",
};

// User-friendly error messages
export const AUTH_ERROR_MESSAGES = {
  [MSAL_ERROR_CODES.BLOCK_NESTED_POPUPS]: {
    title: "Authentication Blocked",
    message: "Pop-up authentication was blocked. Please try signing in again.",
    actionable: true,
  },
  [MSAL_ERROR_CODES.POPUP_WINDOW_ERROR]: {
    title: "Pop-up Blocked",
    message:
      "Unable to open authentication window. Please disable pop-up blockers and try again.",
    actionable: true,
  },
  [MSAL_ERROR_CODES.MONITOR_WINDOW_TIMEOUT]: {
    title: "Authentication Timeout",
    message:
      "Authentication timed out. Please check your network connection and try again.",
    actionable: true,
  },
  [MSAL_ERROR_CODES.USER_CANCELLED]: {
    title: "Authentication Cancelled",
    message:
      "You cancelled the authentication process. Sign in is required to continue.",
    actionable: true,
  },
  [MSAL_ERROR_CODES.HASH_EMPTY_ERROR]: {
    title: "Authentication Error",
    message:
      "There was a problem completing authentication. Please try signing in again.",
    actionable: true,
  },
  [MSAL_ERROR_CODES.POST_REQUEST_FAILED]: {
    title: "Network Error",
    message:
      "Unable to connect to authentication service. Please check your network connection.",
    actionable: true,
  },
  [MSAL_ERROR_CODES.INTERACTION_REQUIRED]: {
    title: "Re-authentication Required",
    message:
      "Your session has expired or requires re-authentication. Please sign in again.",
    actionable: true,
  },
  default: {
    title: "Authentication Error",
    message:
      "An unexpected error occurred during authentication. Please try again.",
    actionable: true,
  },
};

/**
 * Gets user-friendly error info for a given MSAL error
 */
export const getAuthErrorInfo = error => {
  if (!error) return null;

  const errorCode = error.errorCode || error.code;
  return AUTH_ERROR_MESSAGES[errorCode] || AUTH_ERROR_MESSAGES.default;
};

/**
 * Checks if an error should be displayed to the user
 */
export const shouldDisplayAuthError = error => {
  if (!error) return false;

  const errorInfo = getAuthErrorInfo(error);
  return errorInfo?.actionable === true;
};
